module.exports = __webpack_public_path__ + "img/eg-5.461287d0.jpg";